import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import * as userStore from "../../../features/user/store/user.store";
import * as authStore from "../../../features/auth/store/auth.store";
import { OutlinedButton } from "../../form-controls/button/outlined-button/outlined-button.component";

import { MainWrapper, LeftCol, RightCol } from "./header.styles";
import { HeaderProps } from "./header.props";
import { HeaderGlobals } from "../header-globals/header-globals.component";
import { TitleStyled } from "../title/title.styles";
import { BackButton } from "../../form-controls/button/back-button/back-button.component";
import { usePageTitle } from "../../../features/navigation/types/pages.functions";

export const Header = (props: HeaderProps) => {
  const dispatch = useDispatch();
  const currentUserId = useSelector(authStore.getUserId);
  const formatedPageTitle = `${props.parentTitle}${props.title}`;

  usePageTitle(formatedPageTitle);

  useEffect(() => {
    if (currentUserId) {
      userStore.fetchUserData(currentUserId);
    }
  }, [currentUserId, dispatch]);

  return (
    <MainWrapper>
      <LeftCol>
        <BackButton showIf={!!props.showBackButton} customGoBack={props.customGoBack} />
        <TitleStyled>{props.title}</TitleStyled>
        <OutlinedButton
          showIf={!!props.button}
          className={props.button?.className ?? ""}
          disabled={props.button?.disabled ?? false}
          onClick={props.button?.action}
          startIcon={props.button?.icon}
          variant={"outlined"}
        >
          {props.button?.title}
        </OutlinedButton>
      </LeftCol>

      <RightCol>
        <HeaderGlobals />
      </RightCol>
    </MainWrapper>
  );
};
Header.defaultProps = {
  parentTitle: "",
};
